<template>
    <div class="page-container reports-page">
        <div class="page-content">
            <div class="page-header">
                <h1>{{ $t('Напоминания') }}</h1>

                <RightSideUserControls />
            </div>

            <div class="reports-container">
                <div class="chart-header">
                    <!-- <h4>In October, you spent <b>18 000 ₴</b></h4> -->
                    <h4 v-html="chartText"></h4>

                    <multiselect 
                        v-model="selectedAccounts" 
                        :multiple="true"
                        :options="accounts" 
                        :placeholder="$t('Оберіть рахунки')"
                        :preserve-search="true"
                        label="title" 
                        track-by="id" 
                        class="form-control without-tags">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__single multiselect__count_label" v-if="!isOpen">
                                {{ (values.length == accounts.length || values.length == 0) ? 'Всі рахунки' : `${values.length} рахунки` }}
                            </span>
                        </template>
                        <template slot="caret">
                            <div class="caret">
                                <i class="icon icon-chevron-down"></i>
                            </div>
                        </template>
                        <template slot="tag">
                            <div class="d-none"></div>
                        </template>
                        <template slot="placeholder">
                            <div></div>
                        </template>
                    </multiselect>

                    <multiselect 
                        v-model="period" 
                        :searchable="false" 
                        :allow-empty="false" 
                        :options="periods" 
                        :placeholder="$t('Период')" 
                        label="name" 
                        track-by="key" 
                        class="form-control">
                        <template slot="singleLabel" class="signle-lable" slot-scope="props">
                            <div class="label">
                                <span>{{ props.option.name }}</span>
                            </div>
                        </template>
                        <template slot="caret">
                            <div class="caret">
                                <i class="icon icon-chevron-down"></i>
                            </div>
                        </template>
                    </multiselect>
                </div>

                <MainChart :chartData="chartData" :format="chartFormat" />

                <div class="top-categories">
                    <div class="top-categories-col" v-for="(chunk, chunkIndex) in topCategories" :key="`${chunkIndex}-chunk`">
                        <div class="top-categories-item" v-for="(item, index) in chunk" :key="index">
                            <span class="top-categories-item-icon">{{ item.icon }}</span>
                            <span class="top-categories-item-title">{{ item.title }}</span>

                            <span class="top-categories-item-amount">{{ item.amount | money }} {{ currency | currency }}</span>
                        </div>
                    </div>
                </div>

                <div class="facts" v-if="features.show_reports_facts">
                    <div class="facts-title">
                        <h3>Декілька фактів</h3>
                    </div>
                    <div class="facts-list">
                        <div class="facts-item" v-for="(item, index) in facts" :key="`${index}-fact`">
                            <span class="facts-item-icon">{{ item.icon }}</span>
                            <div class="facts-item-title">
                                <span class="facts-item-name">
                                    {{ item.name }}
                                </span>
                                <span class="facts-item-subtitle">
                                    {{ item.title }}
                                </span>
                            </div>

                            <span class="facts-item-amount">{{ item.amount | money }} {{ currency | currency }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RightSideUserControls from "@/new/components/RightSideUserControls.vue";
import MainChart from "@/new/components/Reports/MainChart.vue";
import { EventBus } from '../../../event-bus';

export default {
    name: "Reports",

    components: {
        RightSideUserControls,
        MainChart
    },

    data: function() {
        return {
            chartText: "",
            chartFormat: "month",
            
            chartData: [
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
                {date: "...", value: '0', currency: 'uah', isCurrent: false},
            ],

            facts: [
                {
                    name: 'Больше всего потрачено',
                    icon: '❤️',
                    title: 'Здоровля',
                    amount: 10000,
                    currency: 'uah',
                },
                {
                    name: 'Самая большая покупка',
                    icon: '🛒',
                    title: 'Продукти',
                    amount: 25000,
                    currency: 'uah',
                },
                {
                    name: 'Самый большой перевод',
                    icon: '🏠',
                    title: 'Для дому',
                    amount: 30000,
                    currency: 'uah',
                },
            ],

            topCategories: [],

            periods: [
                {name: 'Последние 7 дней', key: "7d"},
                {name: 'Текущая неделя', key: "week"},
                {name: 'Текущий месяц', key: "month"},
                {name: 'Последние 30 дней', key: "30d"},
                {name: 'Текущий год', key: "year"},
                {name: 'Последние 365 дней', key: "365d"},
            ],

            period: {name: 'Текущий год', key: "year"},
            selectedAccounts: [],
        };
    },

    mounted() {
        if(localStorage.getItem('reports.mainChart.period') !== null) {
            try {
                this.period = JSON.parse(localStorage.getItem('reports.mainChart.period'));
            } catch(e) {
                console.log(e);

                this.period = {name: 'Текущий год', key: "year"};
            }
        }

        this.loadAccounts();

        this.selectedAccounts = this.accounts;

        this.loadMainChart();
        this.loadTopCategories();
    },

    watch: {
        period: function() {
            localStorage.setItem('reports.mainChart.period', JSON.stringify(this.period));

            this.loadMainChart();
            this.loadTopCategories();
        },

        selectedAccounts: function() {
            this.loadMainChart();
            this.loadTopCategories();
        }
    },

    computed: {
        ...mapGetters(['features', 'currency', 'accounts']),
    },

    methods: {
        ...mapActions(['loadAccounts']),

        loadMainChart() {
            let accounts = this.selectedAccounts.map(account => account.id);

            axios.post(`/reports/main`, {
                    period: this.period.key,
                    accounts: accounts,
                })
                .then(({data}) => {
                    this.chartFormat = data.data.format;
                    this.chartData = data.data.values;
                    this.chartText = data.data.text;
                });
        },

        loadTopCategories() {
            let accounts = this.selectedAccounts.map(account => account.id);

            axios.post(`/reports/top`, {
                    period: this.period.key,
                    accounts: accounts,
                })
                .then(({data}) => {
                    this.topCategories = data.data;
                });
        },
    }
}
</script>

<style scoped lang="scss">
.reports-page {
    .page-content {
        flex-wrap: wrap;

        .page-header {
            width: 100%;
        }

        .reports-container {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            width: 100%;
            margin-bottom: 25px;

            .chart-header {
                display: flex;
                align-items: center;
                width: 100%;

                h4 {
                    margin: 0;
                    color: rgba(#152640, .5);

                    font-size: 14px;
                    font-family: 'Proxima Nova Lt';
                    font-weight: 600;

                    b {
                        color: #152640;
                    }

                    margin-right: auto;
                }

                .form-control {
                    width: 200px;
                    margin-left: 10px;
                }
            }

            .top-categories {
                width: 100%;
                display: flex;
                gap: 20px;

                .top-categories-col {
                    display: flex;
                    flex-direction: column-reverse;
                    justify-content: flex-end;
                    width: 100%;
                    max-width: 32%;

                    .top-categories-item {
                        padding: 15px;
                        font-size: 16px;
                        display: flex;
                        width: calc(100% - 30px);
                        background: #fff;
                        border-radius: 5px;
                        margin: 7.5px 0px;
                        color: #152640;

                        .top-categories-item-icon {
                            margin-right: 10px;
                        }

                        .top-categories-item-title {
                            font-family: "Proxima Nova Lt";
                            font-weight: 600;
                        }

                        .top-categories-item-amount {
                            margin-left: auto;
                        }
                    }
                }
            }

            .facts {
                width: 100%;

                .facts-title {
                    h3 {
                        font-size: 18px;
                        font-family: "Proxima Nova Lt";
                        font-weight: 600;
                        color: #152640;
                        margin: 0;
                        margin-bottom: 10px;
                    }
                }

                .facts-list {
                    display: flex;
                    width: 100%;
                    gap: 20px;

                    .facts-item {
                        padding: 15px;
                        font-size: 16px;
                        display: flex;
                        width: calc(100% - 30px);
                        background: #fff;
                        border-radius: 5px;
                        margin: 7.5px 0px;
                        color: #152640;
                        align-items: center;

                        .facts-item-icon {
                            margin-right: 10px;
                            font-size: 20px;
                        }

                        .facts-item-title {
                            display: flex;
                            flex-direction: column;

                            .facts-item-name {
                                font-size: 12px;
                                color: rgba(#152640, .7);
                            }

                            .facts-item-subtitle {
                                font-weight: bold;
                            }
                        }

                        .facts-item-amount {
                            margin-left: auto;
                        }
                    }
                }
            }
        }
    }
}
</style>